import { Button } from '@athena/forge';
import AmplitudeUtils from '../../utils/amplitude-utils';
import { onBackToSignIn } from '../../utils/widget-facade';
import { getLocalizedString } from '../../utils/i18n-utils';


export default function BackToLogin({ oktaButton }: { oktaButton?: JQuery }) {
  const buttonText = getLocalizedString('goback');
  return (
    <Button
      text={buttonText}
      onClick={async () => {
        AmplitudeUtils.logCustomEvent('Footer::BackToLoginButtonClick', {});
        await onBackToSignIn();
        oktaButton?.trigger('click');
      }}
      variant="tertiary"
      size="small"
    />
  );
}
